import { t } from 'i18next';

export type ScoreCardProps = {
  $scoreName: string;
};

export type ScoreContent = {
  score: string;
  content: string;
};

export type ScanStatus = {
  passed: ScoreContent;
  failed: ScoreContent;
};

export const getAccessibilityScoreDic = (
  accessibilityScore?: number,
  amountOfIssues?: number
): Record<string, ScanStatus> => ({
  status: {
    passed: {
      score: t('free_tools.accessibility_checker.a11y_results.compliant'),
      content: t('free_tools.accessibility_checker.a11y_results.high_compliance'),
    },
    failed: {
      score: `${amountOfIssues} ${t('free_tools.accessibility_checker.a11y_results.violations')}`,
      content: t('free_tools.accessibility_checker.a11y_results.not_compliant'),
    },
  },
  score: {
    passed: {
      score: `${accessibilityScore}%`,
      content: `${t(
        'free_tools.accessibility_checker.a11y_results.you_are'
      )} ${accessibilityScore}% ${t(
        'free_tools.accessibility_checker.a11y_results.compliant_with_wcag'
      )}`,
    },
    failed: {
      score: `${accessibilityScore}%`,
      content: t('free_tools.accessibility_checker.a11y_results.high_risk'),
    },
  },
  compliance: {
    passed: {
      score: t('free_tools.accessibility_checker.a11y_results.low'),
      content: t('free_tools.accessibility_checker.a11y_results.compliance_risk'),
    },
    failed: {
      score: t(
        accessibilityScore && accessibilityScore > 70
          ? 'free_tools.accessibility_checker.a11y_results.mild'
          : 'free_tools.accessibility_checker.a11y_results.high'
      ),
      content: `${amountOfIssues} ${t(
        'free_tools.accessibility_checker.a11y_results.violations_detected'
      )}`,
    },
  },
});
